// Support service for handling contact form submissions
const API_URL = 'https://u3p6nj4we2oia3okd36myeocya0tkuog.lambda-url.us-east-2.on.aws/';

/**
 * Interface for support request data
 */
export interface SupportRequest {
  email: string;
  question: string;
}

/**
 * Submit a support request
 * @param supportData - The support request data containing email and question
 * @returns Promise<boolean> - True if successful, false otherwise
 */
export const submitSupportRequest = async (supportData: SupportRequest): Promise<boolean> => {
  try {
    console.log('Submitting support request:', { email: supportData.email, questionLength: supportData.question.length });
    
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Note: Lambda Function URLs don't typically need API keys
        // Remove this if you're not using API key authentication
        // 'x-api-key': process.env.REACT_APP_API_KEY_SUPPORT || process.env.REACT_APP_API_KEY_REGISTRY || ''
      },
      body: JSON.stringify({
        operation: 'submitContactForm',
        email: supportData.email,
        question: supportData.question,
        timestamp: new Date().toISOString()
      })
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('HTTP error response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const responseData = await response.json();
    console.log('Response data:', responseData);
    
    // Lambda Function URLs return the response directly (no body wrapper like API Gateway)
    return responseData.success === true;
    
  } catch (error) {
    console.error('Error submitting support request:', error);
    return false;
  }
};

/**
 * Validate support request data
 * @param supportData - The support request data to validate
 * @returns string - Empty string if valid, error message if invalid
 */
export const validateSupportRequest = (supportData: SupportRequest): string => {
  if (!supportData.email || !supportData.question) {
    return 'Please provide both your email and question';
  }
  
  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(supportData.email)) {
    return 'Please enter a valid email address';
  }
  
  return '';
};
